import WorkItemPersist from '@/domain/work-item/work-item-persist.entity';

export default class WorkItemPostAggregator extends WorkItemPersist {
  assignedTo: string[];

  constructor(obj: any) {
    super(obj);
    this.assignedTo = obj.assignedTo;
  }

  public static of(value: any): WorkItemPostAggregator {
    return new WorkItemPostAggregator(value || {});
  }

  set assignedUserArray(username: any) {
    this.assignedTo = [username];
  }
}
